import React from 'react'
import Box from '@material-ui/core/Box'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import SectionTitle from 'components/section-title'
import TipWell from 'components/tip-well'
import EmojiObjectsIcon from 'components/material-symbol/icons/EmojiObjects'
import useStyles from '../styles'

const AnalyticsCard = ({
  title,
  subtitle,
  summary,
  insight,
  className,
  loading,
  error,
  errorMessage,
  empty,
  emptyMessage,
  flushBody,
  children,
}) => {
  const classes = useStyles()

  const renderBody = () => {
    if (error) {
      return (
        <Box className={`${classes.chartMessage} ${classes.messageError}`}>
          {errorMessage}
        </Box>
      )
    }
    if (loading) {
      return <LinearProgress color="primary" className={classes.loading} />
    }
    if (empty) {
      return <Box className={classes.chartMessage}>{emptyMessage}</Box>
    }
    return (
      <>
        {children}
        {insight ? (
          <Box className={classes.insightTip}>
            <TipWell
              variant="neutral"
              icon={EmojiObjectsIcon}
              copyClassName={classes.insightTipCopy}
              iconClassName={classes.insightTipIcon}
              caption={insight}
            />
          </Box>
        ) : null}
      </>
    )
  }

  return (
    <Box className={`${classes.card} ${className || ''}`}>
      <Box className={classes.cardHeader}>
        <Box className={classes.cardTitleBlock}>
          <SectionTitle size="card" className={classes.cardTitle}>
            {title}
          </SectionTitle>
          {subtitle ? (
            <Typography className={classes.cardSubtitle}>{subtitle}</Typography>
          ) : null}
        </Box>
        <Box className={classes.cardHeaderRight}>
          {summary ? (
            <Box className={classes.cardSummary}>{summary}</Box>
          ) : null}
        </Box>
      </Box>
      <Box
        className={`${classes.cardBody} ${
          flushBody ? classes.cardBodyFlush : ''
        }`}
      >
        {renderBody()}
      </Box>
    </Box>
  )
}

export default AnalyticsCard
